import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import './threaditem.css';
import Card from '@bit/super-mario.yoshi.card';

class ThreadItem extends Component {

  handleClick() {
    const { thread } = this.props;
    const threadUrl = '/b/' + thread.id;
    this.props.history.push(threadUrl);
  }

  render() {
    const { thread } = this.props;
    const { user } = thread || {};
    const { isCreator } = this.props;
    const threadUrl = 'thread/' + thread.id;
    const editUrl = 'edit-thread/' + thread.id;

    const metadata = thread.metadata || {};
    const description = metadata.description || '';
    const imageUrl = metadata.image || 'https://designshack.net/wp-content/uploads/placeholder-image.png';

    const data = {
      title: thread.title,
      description,
      imageUrl: thread.theme_image || imageUrl,
      targetUrl: threadUrl,
      statistics: thread.statistics,
      user: thread.user
    }
    if (thread && user && user.name && user.id && thread.url && thread.title) {
      const chatPageUrl = `/thread/${thread.id}`;
      return (
        <div className='thread-item'>
          <Card {...data} />
          { isCreator &&
            <Link className='create-button' to={{
                pathname: editUrl,
                state: { thread }
              }}>
                Edit
            </Link>
          }
          <a href={chatPageUrl}>Chat now</a>
        </div>
      )
    }
    return null;
  }
}

export default withRouter(ThreadItem);